import { useContext } from "react";
import { DisplayOptionContext } from "@/context/DisplayOptionContext";

export const useDisplayOptionContext = () => {
    const context = useContext(DisplayOptionContext);
    if (!context) {
        throw new Error(
            "useDisplayOptionContext must be used within a DisplayOptionContext.Provider",
        );
    }
    return context;
};
